import Icon from 'veui/components/Icon'
import { IconCoin } from 'dls-icons-vue'

Icon.register('coin', IconCoin)
